import FadeIn from "react-fade-in/lib/FadeIn";
import SearchBar from "../../../atom/search";
import { useEffect, useRef, useState } from "react";
import AgentInfoCard from "../queueMonitor/agentInfoCard";
import TableTopBar from "../../modal/tableTopBar";
import { useSelector } from "react-redux";
import { getToken } from "../../../services/api";
import { getENVData } from "../../../config/environment";
import CustomTooltip from "../../../atom/customTooltip";
import { useParams } from "react-router-dom";
let intervalId: any;
function UserPanel() {
  const { id } = useParams();
  console.log("id", id);
  const tabs = [
    { name: "State" },
    { name: "Extension" },
    { name: "First Name" },
    { name: "Last Name" },
  ];

  const isComponentMounted = useRef(false); // To track if the component is mounted
  const accessToken = useSelector((state: any) => state.auth.token);
  const [sortBy, setSortBy] = useState<string>("State");
  const [searchtext, setSearchText] = useState<any>("");
  const [eventsData, setEventsData] = useState<any>([]);
  const socketRef = useRef<WebSocket | null>(null);
  const messageBuffer = useRef<string[]>([]);
  const [handleKeyPress, setHandleKeyPress] = useState<boolean>(true);
  const [showNoResults, setShowNoResults] = useState(false);

  const connectWebSocket = () => {
    if (!isComponentMounted.current) return;
    const wssUrl = getENVData().baseURL.replace("https", "wss");
    // Only create the WebSocket if it hasn't been created yet
    const url = `${wssUrl}events/liveboard/tenants/${getToken()}/ws/users/${id}?token=${accessToken}`;
    console.log("wssUrl", url);
    if (!socketRef.current) {
      socketRef.current = new WebSocket(url);
      socketRef.current.addEventListener("open", (event) => {
        console.log("Connected to WebSocket", event);
      });

      socketRef.current.addEventListener("message", (event) => {
        // console.log("Message received from server:", event.data);
        const data = JSON.parse(event.data);
        if (data?.event === "user.create") {
          messageBuffer.current.push(data);
          // setEventsData((prevEvents: any) => [...prevEvents, data]);
          // onHandleSort("State");
        }
        if (data?.event === "user.update") {
          // console.log("user.update", data);
          setEventsData((prevEvents: any) =>
            prevEvents.map((event: any) =>
              event.uuid === data.uuid ? { ...event, ...data } : event,
            ),
          );
          // onHandleSort(sort);
        }
        if (data?.event === "user.delete") {
          setEventsData((prevEvents: any) =>
            prevEvents.filter((event: any) => event.uuid !== data.uuid),
          );
        }
      });

      socketRef.current.addEventListener("close", (e: Event) => {
        if (isComponentMounted.current) {
          console.log("WebSocket connection closed", socketRef.current, e);
          console.log("WebSocket connection closed Attempting to reconnect...");
          socketRef.current = null;
          reconnectWebSocket();
        } else {
          console.log(
            "WebSocket closed and no reconnect as component is unmounted.",
          );
        }
      });
      socketRef.current.addEventListener("error", (error) => {
        console.error("WebSocket encountered an error:", error);
        if (socketRef.current) {
          socketRef.current.close(1000, "Normal closure"); // Close the connection on error
        }
      });
    }
    intervalId = setInterval(() => {
      if (messageBuffer.current.length > 0) {
        setEventsData((prevEvents: any) => [
          ...prevEvents,
          ...messageBuffer.current,
        ]);
        messageBuffer.current = []; // Clear the buffer after processing
      }
    }, 100);
  };
  const reconnectWebSocket = () => {
    if (!isComponentMounted.current) return; // Stop reconnecting if the component is unmounted
    setTimeout(() => {
      console.log("Reconnecting WebSocket...");
      connectWebSocket(); // Retry connection
    }, 3000); // Retry after 3 seconds
  };
  useEffect(() => {
    setEventsData(() => []);
    isComponentMounted.current = true; // Component is mounted
    if (socketRef.current) {
      socketRef.current.close(1000, "Normal closure");
      console.log("WebSocket closed during cleanup");
    }
    setTimeout(connectWebSocket, 100);
    return () => {
      isComponentMounted.current = false; // Component is mounted
      if (socketRef.current) {
        socketRef.current.close(1000, "Normal closure");
        console.log("WebSocket closed during cleanup");
        // setTimeout(connectWebSocket, 3000);
      }
      console.log("socketRef", socketRef);
      clearInterval(intervalId); // Cleanup the interval
    };
  }, []);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setShowNoResults(true);
    }, 3000); // 3 seconds delay

    return () => clearTimeout(timeout); // cleanup
  }, []);

  const handleSearch = (e: any) => {};

  return (
    <div data-testid="userPanel" className="h-full py-3 flex relative gap-2.5">
      <div className=" h-[calc(100vh-125px)]  lg:w-[calc(100vw-120px)] w-[calc(100vw-90px)] rounded-md bg-[#FFFFFF] overflow-hidden">
        <FadeIn>
          {/* Top */}
          <div className="py-5 px-3 sm:px-4">
            <TableTopBar
              title={"User Panel"}
              search={true}
              searchtext={searchtext}
              handleSearch={handleSearch}
              setSearchText={setSearchText}
              handleKeyPress={handleKeyPress}
              setHandleKeyPress={setHandleKeyPress}
              // filterTable={filterTable}
            />
          </div>
          {/*  */}
          <div className="flex gap-2 sm:gap-4 px-3 sm:px-8 overflow-x-auto no-scrollbar">
            <p className="mt-1.5 shrink-0">Sort by</p>

            {tabs.map((item: any, index: number) => {
              return (
                <div
                  key={index}
                  className={`rounded-lg h-min-[40px] shrink-0 break-words ${
                    sortBy === item.name
                      ? "text-[#AB5D0A] font-bold bg-[#FEF4E9]"
                      : "bg-[#EBEBEB80]"
                  } text-center bg-[#EBEBEB80] h-[38px] px-3 cursor-pointer hover:bg-[#FEF4E9] hover:text-[#AB5D0A]   flex justify-center items-center`}
                  onClick={() => setSortBy(item.name)}
                >
                  {item.name}
                </div>
              );
            })}
          </div>
          {/* main body */}

          {/* main body */}
          <div className="w-full mt-4 px-3 sm:px-8 grid xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-4 overflow-y-auto max-h-[calc(100vh-270px)]">
            {(() => {
              const filteredAndSortedData = eventsData
                ?.filter((user: any) => {
                  if (!searchtext) return true;

                  const fullName =
                    `${user.first_name} ${user.last_name}`.toLowerCase();
                  const extension = user.extension?.toLowerCase() || "";
                  const search = searchtext.toLowerCase();

                  return (
                    fullName.includes(search) || extension.includes(search)
                  );
                })
                .sort((a: any, b: any) => {
                  if (sortBy === "State") {
                    const getPriority = (event: any) => {
                      if (!event.is_logged_in) return 3;
                      if (event.ph_state === "idle") return 2;
                      if (event.ph_state === "busy") return 1;
                      return 4;
                    };
                    return getPriority(a) - getPriority(b);
                  }

                  if (sortBy === "Extension") {
                    return (a.extension || "").localeCompare(b.extension || "");
                  }

                  if (sortBy === "First Name") {
                    return (a.first_name || "").localeCompare(
                      b.first_name || "",
                    );
                  }

                  if (sortBy === "Last Name") {
                    return (a.last_name || "").localeCompare(b.last_name || "");
                  }

                  return 0;
                });

              if (
                showNoResults &&
                (!filteredAndSortedData || filteredAndSortedData.length === 0)
              ) {
                return (
                  <div className="col-span-full flex items-center justify-center h-[calc(100vh-300px)]">
                    <b>No Results Found</b>
                  </div>
                );
              }

              return filteredAndSortedData?.map((node: any) => (
                <div key={node.uuid}>
                  <AgentInfoCard page="main" data={node} />
                </div>
              ));
            })()}
          </div>
        </FadeIn>
      </div>
    </div>
  );
}

export default UserPanel;
